// @ts-nocheck
if (typeof (window['acquireVsCodeApi']) !== 'function') {
    window['acquireVsCodeApi'] = function () {
        return {};
    }
}
export default acquireVsCodeApi();